import { TMonitoringIgnoreOption } from './types';

const ignoreErrors: TMonitoringIgnoreOption = [
  'isProxied', // Ошибка в Angular/Ionic / не влияет на работу приложения
  "Cannot read properties of undefined (reading 'speed')", // Ошибка в библиотеке swiper / не влияет на работу приложения
  "undefined is not an object (evaluating 'this.params.speed')", // Ошибка в библиотеке swiper / не влияет на работу приложения

  // Неизвестные ошибки
  'Load failed',
  'network error',
  'Failed to fetch',
  "Can't find variable: disableWebkitEnterFullscreen",
  /Http failure response for assets\/images\/icons-svg.+Unknown Error/,
  /pe.handleError/,
  /handleError is not a function/,
  /Script error/,

  // Ошибки загрузки чанков после релиза
  'ChunkLoadError',
  /Loading chunk [\d]+ failed/,

  // Ошибки браузера и расширений браузера
  "Can't find variable: gmo", // Google Chrome на iPhone
  'Unable to open database file on disk', // IndexedDB / WebKit на iOS (Safari, YaBrowser и др.)
  'Error invoking post: Method not found', // Android WebView / bridge / расширения
  'Error invoking postEvent: Method not found', // Android WebView / bridge / расширения
  'WKWebView API client did not respond to this postMessage', // DuckDuckGo / iOS WKWebView bridge

  // Firebase / сеть
  'installations/app-offline', // Firebase Installations при отсутствии сети
];

export default ignoreErrors;
